// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__-gqkm","items":"styles_items__ywX0E","itemsWrapper":"styles_itemsWrapper__OIxq2"};